import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, useTheme } from '@material-ui/core/styles';
import { Radio } from '@material-ui/core';
export function MRadio({ color = 'primary', sx, ...other }) {
    const theme = useTheme();
    if (color === 'default' || color === 'primary' || color === 'secondary') {
        return _jsx(Radio, Object.assign({ color: color, sx: sx }, other), void 0);
    }
    return (_jsx(Radio, Object.assign({ sx: {
            '&.Mui-checked': {
                color: theme.palette[color].main,
            },
            '&:hover, &.Mui-checked:hover': {
                bgcolor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity),
            },
            ...sx,
        } }, other), void 0));
}
//# sourceMappingURL=MRadio.js.map